<template>
  <ten-list
    class="ten-list--card"
    :title="title"
    :data="data"
    :columns="columns"
    :direction="direction"
    :infinite-scroll="infiniteScroll"
  >
    <template v-slot:item="{ item }">
      <div
        class="ten-list__item__card"
        @click="_click(item)"
      >
        <ten-card>
          <template slot="thumb">
            <slot
              name="thumb"
              :item="item"
            />
          </template>
          <template slot="header">
            <slot
              name="header"
              :item="item"
            />
          </template>
          <template slot="default">
            <slot
              name="default"
              :item="item"
            />
          </template>
          <template slot="footer">
            <slot
              name="footer"
              :item="item"
            />
          </template>
        </ten-card>
      </div>
    </template>
  </ten-list>
</template>

<script>
import TenList from './list.vue';
import TenCard from '../card/card.vue';

export default {
  components: {
    TenList,
    TenCard,
  },
  props: {
    /**
     * 列表的标题，不传不展示 header 部分
     */
    title: {
      type: String,
      default: '',
    },

    /**
     * 列表分多少栏
     */
    columns: {
      type: Number,
      default: 1,
    },

    /**
     * 分栏的时候，元素朝哪个方向排列。
     * row 从左往右排列
     * column 从上往下排列
     */
    direction: {
      type: String,
      default: 'row',
    },

    /**
     * 数据
     */
    data: Array,

    /**
     * 无限下拉加载
     */
    infiniteScroll: Function,
  },
  methods: {
    _click(item) {
      /**
       * 点击一个卡片时触发
       * @param {object} item 被点击的item
       */
      this.$emit('item-click', item);
    },
  },
};
</script>
